import React from 'react'
import PropTypes from 'prop-types'
import { useInView } from 'react-intersection-observer'
import { FadeInWrapper } from './index.style'
import { useContext } from 'react'
import { StoreState } from '../../../Store'

const AnimateFadeIn = ({
  delay = 0,
  triggerOnce = true,
  animate = true,
  children,
}) => {
  const [ref, inView] = useInView({ triggerOnce })
  const store = useContext(StoreState)
  const { showTransitionMask } = store

  return (
    <FadeInWrapper
      ref={ref}
      inView={inView && animate && !showTransitionMask}
      delay={delay}
    >
      {children}
    </FadeInWrapper>
  )
}

AnimateFadeIn.propTypes = {
  children: PropTypes.node,
  delay: PropTypes.number,
  triggerOnce: PropTypes.bool,
  animate: PropTypes.bool,
}

export default AnimateFadeIn
